module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.$l('streamPopover/title')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.$p('streamPopover/audio')) ? _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.audioClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('streamPopover/Audio')))]) : _vm._e(), _vm._v(" "), (_vm.url) ? _c('div', {
    staticClass: "audio-iframe"
  }, [_c('el-row', {
    staticClass: "audio-buttons",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "audio-button",
    attrs: {
      "disabled": !_vm.audioPlaying,
      "size": "small"
    },
    on: {
      "click": _vm.audioRecordingClicked
    }
  }, [_vm._v(_vm._s(_vm.$l(_vm.recordingButtonText)))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "audio-button",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.stopAudioStreamClicked
    }
  }, [_vm._v(_vm._s(_vm.$l(_vm.streamButtonText)))])], 1)], 1), _vm._v(" "), (_vm.audioPlaying) ? _c('audio', {
    ref: "audioController",
    staticClass: "audio-controller",
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$p('streamPopover/video') && _vm.getSettingsAddons.video == '1') ? _c('div', {
    staticClass: "option",
    class: _vm.getClass('video'),
    on: {
      "click": _vm.videoClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('streamPopover/Video')))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e0249b8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/StreamPopover.vue
// module id = 465
// module chunks = 1